import React, { useState, useEffect } from "react";

import '../../assets/styles/App.css';
import "@fontsource/montserrat";


export default function CardError(props) {
  const [message, setMessage] = useState('');
  const [link, setLink] = useState('');
  const [linkDescription, setLinkDescription] = useState('');

  useEffect(() => {
    setMessage(props.message);
    setLink(props.link);
    setLinkDescription(props.description);

  }, [props.message, props.link, props.description]);
  return (
    <>
            <div className="container relative mx-auto items-center bg-white-10 rounded-lg mt-12">
              <h3 className="text-24-500 text-white text-center py-16">{message}
                {(link !== '' && linkDescription !== '') ?
                  ( <>
                  <a href={link}>{linkDescription}</a>
                  </>): <></>
                }
              </h3>
              <br/>
            </div>
    </>
  );
}